const initCollapsibleText = () => {
  const sections = document.querySelectorAll('section[data-section-type="text"]');
  sections.forEach(section => {
    const content: HTMLElement | null = section.querySelector('.text__content');
    const button = section.querySelector('button[data-toggle]');
    
    if (content && button) {
      button.addEventListener('click', function () {
        if (content.style.maxHeight === 'none') {
          content.style.maxHeight = '3rem';
          button.textContent = 'Read More';
        } else {
          content.style.maxHeight = 'none';
          button.textContent = 'Read Less';
        }
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initCollapsibleText()
});
